import { FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { TTBLLogoWhite } from "./common/SVG";
import Image from "next/image";
import Link from "next/link";
import { LanguageSwitch } from "./LanguageSwitch";
import { useTranslation } from "next-i18next";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="">
      <div className="container">
        <div className="flex max-md:justify-center md:hidden">
          <TTBLLogoWhite className="footer_logo" />
        </div>
        <div className="flex justify-center md:justify-between md:gap-8 flex-col md:flex-row">
          <div className="md:flex-1">
            <TTBLLogoWhite className="footer_logo mt-2 text-center hidden md:block" />
          </div>
          <div>
            <h3 className="text-center">TTBL Partner</h3>
            <div className="gap-4 sm:gap-8 justify-center px-7 md:px-0 grid grid-cols-3 md:flex">
              <div>
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/liebherr_logo_original.png"
                    alt="Logo Liebherr"
                    className="footer_logo_partner logo_liebherr"
                    width={1000}
                    height={136}
                  />
                </Link>
              </div>
              <div>
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/ASS_Ich_bin_Dein_Auto.png"
                    alt="Logo ASS Ich bin dein Auto"
                    className="footer_logo_partner logo_auto"
                    width={709}
                    height={367}
                  />
                </Link>
              </div>
              <div className="relative">
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/tickaroo_white.png"
                    alt="Logo Tickaroo"
                    className="footer_logo_partner logo_tickaroo"
                    width={173}
                    height={37}
                  />
                </Link>
              </div>
              <div>
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/bcm-logo-negativ-mit-claim-weiß.png"
                    alt="Logo BCM"
                    className="footer_logo_partner logo_auto"
                    width={709}
                    height={367}
                  />
                </Link>
              </div>
              <div>
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/Riddle_logo_quer-weiß.png"
                    alt="Logo Riddle"
                    className="footer_logo_partner logo_auto"
                    width={709}
                    height={367}
                  />
                </Link>
              </div>
              <div>
                <Link href="/about/partners">
                  <Image
                    suppressHydrationWarning
                    src="/logos/solitus_logo_dunkel_frei-weiß.png"
                    alt="Logo Solitus"
                    className="footer_logo_partner logo_auto"
                    width={709}
                    height={367}
                  />
                </Link>
              </div>
            </div>
          </div>
          <hr className="md:hidden my-5" />
          <div className="md:flex-1 inline-flex flex-col items-end">
            <h3 className="hidden md:block md:text-right">
              TTBL on Social Media
            </h3>
            <div className="flex gap-4 sm:gap-8 justify-between sm:justify-center px-7 md:px-0 social-icons">
              <a href="https://www.facebook.com/ttbuli" target="_blank">
                <FiFacebook />
              </a>
              <a
                href="https://www.youtube.com/channel/UCRnDl9NtKQDZVLn06Bwskrg"
                target="_blank"
              >
                <FiYoutube />
              </a>
              <a href="https://www.instagram.com/ttbuli/" target="_blank">
                <FiInstagram />
              </a>
              <div>
                <a
                  href="https://www.tiktok.com/@ttbl?lang=de-DE"
                  target="_blank"
                >
                  <svg
                    width="19.9400095px"
                    height="22.9421458px"
                    viewBox="0 0 19.9400095 22.9421458"
                    version="1.1"
                  >
                    <title>TikTok</title>
                    <g
                      id="Symbols"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="social_media/tiktok"
                        transform="translate(-2.029990, -0.530000)"
                        fill="#FFFFFF"
                        fillRule="nonzero"
                      >
                        <path
                          d="M16.0783095,0.53 C16.6140257,0.53 17.0483095,0.964283793 17.0483095,1.5 C17.0483095,2.59453336 17.4021849,3.51552625 18.1257089,4.30933423 C18.8304774,5.08256474 19.7805432,5.49162687 21.0370784,5.53969327 C21.5579868,5.55961964 21.97,5.987695 21.97,6.50898434 L21.97,10.1299028 C21.97,10.6920236 21.4937071,11.1364479 20.9329316,11.0975814 C19.6541347,11.0089498 18.7049083,10.8674519 18.0566642,10.658801 C17.7975308,10.5753934 17.511988,10.4587729 17.1984434,10.3087819 L17.076,10.248 L17.0768335,15.2802777 C17.0768335,19.6983286 14.3948171,22.7709791 10.7633984,23.3692415 L10.5252386,23.4047389 C6.16730099,23.9864654 2.13532727,20.7391823 2.03222645,16.1281586 C1.9284344,11.4862205 5.45033963,7.99545723 10.0485885,8.25668262 C10.562104,8.28585531 10.9635718,8.71077768 10.9635718,9.22512114 L10.9635718,12.9202636 C10.9635718,13.5062034 10.4480533,13.9583734 9.86711416,13.8819852 C8.47976781,13.6995618 7.50910686,14.6748952 7.50910686,15.9696903 C7.50910686,17.0884542 8.53095384,18.0049974 9.53367377,17.8891666 C10.9931404,17.720574 11.5371899,17.1748543 11.5371899,15.2802777 L11.5371899,1.5 C11.5371899,0.964283793 11.9714736,0.53 12.5071899,0.53 L16.0783095,0.53 Z M15.18,2.47 L13.477,2.47 L13.4771899,15.2802777 C13.4771899,18.1211004 12.2305966,19.4576063 9.97108516,19.7882817 L9.75629556,19.8163509 C7.59867802,20.0655916 5.56910686,18.2451726 5.56910686,15.9696903 C5.56910686,13.951119 6.92837535,12.2579716 8.90694722,11.9641214 L9.023,11.95 L9.023,10.207 L8.84445072,10.2251151 C6.02118694,10.5579817 4.00201479,12.8311005 3.97036994,15.8564952 L3.97174168,16.0847917 C4.04837865,19.5122609 7.03052267,21.914029 10.2685513,21.4817954 C13.0678853,21.1081216 15.1368335,18.8103463 15.1368335,15.2802777 L15.1368335,8.58525093 C15.1368335,7.82357517 15.9744788,7.35906489 16.6205609,7.76246044 C17.4995855,8.31129884 18.1847128,8.66199931 18.6510624,8.81210367 C18.9228601,8.89958745 19.3133895,8.97737226 19.816976,9.04262224 L20.03,9.068 L20.03,7.384 L19.7750764,7.3387547 C18.6409193,7.10721663 17.6702167,6.59975048 16.8844841,5.81747213 L16.6919169,5.61617794 C15.9040565,4.75178387 15.4072075,3.75521033 15.2080243,2.64601355 L15.18,2.47 Z"
                          id="Rectangle-Copy"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr className="text-blue my-5" />
        <div className="md:flex">
          <div className="px-7 md:px-0 sm:text-center md:text-left md:flex-1">
            <div>
              <h3 className="md:m-0">TTBL Sport GmbH</h3>
              <div>Marktstraße 12</div>
              <div className="mb-4 md:mb-0">36037 Fulda</div>
            </div>
          </div>
          <div className="px-7 md:px-0">
            <div className="flex gap-4 sm:justify-center">
              <div>
                <div>Telefon:</div>
                <div>Fax:</div>
                <div>E-Mail:</div>
              </div>
              <div>
                <div>
                  <a href="tel:+4966158018390">+49 661 5801839 0</a>
                </div>
                <div>+49 661 5801839 21</div>
                <div>
                  <a href="mailto:info@ttbl.de">info@ttbl.de</a>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:block md:text-right md:flex-1">
            <Link href="/newsletter">{t("Title_Newsletter")}</Link>
            <div>
              <Link href="/privacy">{t("Title_Privacy_Policy")}</Link>
            </div>
            <div>
              <Link href="/imprint">{t("Title_Imprint")}</Link>
            </div>
          </div>
        </div>
        <hr className="hidden md:block my-5" />
        <div className="hidden md:flex justify-between">
          <div className="md:flex-1">@ 2023 BY TTBL SPORT GMBH</div>
          <div>
            <LanguageSwitch type="big" />
          </div>
          <div className="md:flex-1 inline-flex justify-end">
            <a
              href="https://madeby.tickaroo.com/"
              target="_blank"
              className="align-top"
            >
              POWERED BY{" "}
              <Image
                suppressHydrationWarning
                src="/logos/made-by_white.png"
                alt="Logo made.by"
                className="footer_logo_partner logo_made ml-2"
                width={300}
                height={380}
              />
            </a>
          </div>
        </div>
        <hr className="md:hidden my-5" />
        <div className="grid gap-x-4 grid-cols-2 md:hidden footer_nav px-7">
          <Link href="/tickets" className="sm:text-right">
            Tickets
          </Link>
          <Link
            href="/bundesliga/gameschedule/current/all/1"
            className="text-right sm:text-left"
          >
            Ligaspiele
          </Link>
          <Link href="/pokal/finals" className="sm:text-right">
            Pokal-Finale
          </Link>
          <Link href="/bundesliga/finals" className="text-right sm:text-left">
            TTBL-Finale
          </Link>
        </div>
      </div>
    </footer>
  );
}
